import { styled, Typography } from '@nextiva/next-ui-components';

export const StyledLabel = styled(Typography)`
  font-weight: 800;
  margin-bottom: 8px;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: 20px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;
export const StyledRecurringChargesContainer = styled('div')`
  padding-right: 101px;
`;
export const StyledFeesText = styled(Typography)`
  font-weight: 400;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: 20px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;
